var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarMypage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 15,
    viewBox: "0 0 28 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.679688 0.859375H2.30078L7.35938 13.0078H7.49609L12.5352 0.859375H14.1758V15H12.8477V3.73047H12.7305L8.04297 15H6.79297L2.10547 3.73047H1.98828V15H0.679688V0.859375ZM16.2266 0.859375H17.8281L21.9688 7.53906H22.0859L26.2266 0.859375H27.8281L22.7305 8.94531V15H21.3242V8.94531L16.2266 0.859375Z",
    fill: "#232323"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarMypage);
export default __webpack_public_path__ + "static/media/sidebar_mypage.fe83c2ce8f2b69706d537448ae5df360.svg";
export { ForwardRef as ReactComponent };